import apiClient from "./axios"

const normalizeListResponse = response => {
  if (Array.isArray(response && response.data)) return response
  if (Array.isArray(response && response.data && response.data.data)) {
    return Object.assign({}, response, { data: response.data.data })
  }
  return Object.assign({}, response, { data: [] })
}

export const getMoneyReceiptComplimentaryItems = async (params = {}) => {
  const { data } = await apiClient.get("/v1/service-lists", { params })
  return data
}

export const getMoneyReceiptComplimentaryItem = async id => {
  const { data } = await apiClient.get(`/v1/service-lists/${id}`)
  return data
}

export const createMoneyReceiptComplimentaryItem = async (payload, options = {}) => {
  const { data } = await apiClient.post("/v1/service-lists", payload, {
    skipToast: true,
    ...options,
  })
  return data
}

export const updateMoneyReceiptComplimentaryItem = async ({ id, ...payload }) => {
  const { data } = await apiClient.put(`/v1/service-lists/${id}`, payload)
  return data
}

export const deleteMoneyReceiptComplimentaryItem = async id => {
  const { data } = await apiClient.delete(`/v1/service-lists/${id}`)
  return data
}

export const getAllMoneyReceiptComplimentaryItems = async (params = {}) => {
  const { data } = await apiClient.get("/v1/service-lists", {
    params: { ...params, all: true },
  })
  return normalizeListResponse(data)
}

export const searchMoneyReceiptComplimentaryItems = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/v1/service-lists", {
    params: { ...params, search: searchTerm },
  })
  return normalizeListResponse(data)
}
